<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-1">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="8" md="8">
                    <h5 class="mt-2" v-text="Title"></h5>
                  </b-col>
                  <b-col lg="4" md="4">
                    <b-row>
                      <b-col md="6"></b-col>
                      <b-col md="6">
                        <div class="d-flex">
                          <b-button
                            block
                            class="mr-1"
                            @click="editReturnItems"
                            v-if="!disableRefundType"
                            id="edit-return"
                            >Edit Return</b-button
                          >

                          <b-button
                            block
                            v-if="disableRefundType"
                            size="sm"
                            class="mr-1"
                            @click="$router.push('invoices-history')"
                            id="back-invoice-history"
                            >Back to Invoice History</b-button
                          >

                          <!-- <b-button
                            variant="success"
                            block
                            class="mr-1"
                            @click="confirmReturn"
                            :disabled="$loading == true"
                          >
                            <span v-if="$loading == false">Confirm Return</span>
                            <b-spinner small v-if="$loading == true"></b-spinner>
                          </b-button>-->
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <!-- <section>
      <b-container fluid>-->
      <!-- <div
            class="table-dark-bg box-shadow cart-table-wrapper wow fadeIn mt-2 col-md-4 pl-0 pr-0"
          >
            <table class="table cart-table mt-0 table-dark">
              <thead>
                <tr>
                  <th class="text-center">#</th>
                  <th>Product(s)</th>
      <th class="text-center" width="10%">Qty</th>-->
      <!-- <th class="text-left">Reason for Return</th> -->
      <!-- <th class="text-right">Sale Price</th> -->
      <!-- <th class="text-right">Discount</th> -->
      <!-- <th class="text-right pr-4">Net Price</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(items, index) in returnItems" :key="items.index">
                  <td class="text-center" v-text="index+1"></td>
                  <td>
                    {{items.product}}
      <br />-->
      <!-- <span style="color: #808080;">{{items.barcode}}</span> -->
      <!-- </td>
      <td class="text-center">{{items.return_qty}}</td>-->
      <!-- <td> -->
      <!-- {{ items.return_reason == ''?'-':items.return_reason }} -->
      <!-- <b-form-select v-model="returnReasons" :options="options" @change="openCustomRemark()"></b-form-select> -->
      <!-- </td> -->
      <!-- <td class="text-right">{{currencySymbol}} {{items.sale_price}}</td> -->
      <!-- <td class="text-right">{{currencySymbol}} {{items.discount}}</td> -->
      <!-- <td class="text-right pr-4">{{currencySymbol}} {{items.net_price}}</td> -->
      <!-- </tr>
              </tbody>
            </table>
            <hr />
      </div>-->
      <!-- <div class="col-md-4">
            <return-order-summary />
          </div>
        </b-container>
      </section>-->

      <section class="mt-1 return-confirmation">
        <b-container fluid>
          <b-row>
            <div class="col-md-4">
              <div
                class="customer-info table-dark-bg box-shadow p-3 mb-2 return-method"
              >
                <div class="payment-page">
                  <b-row>
                    <b-col lg="12">
                      <b-form-group
                        id="input-group-1"
                        class="pay-amount"
                        label-for="amt-pay"
                      >
                        <label class="mb-1">
                          <span>Refund Amount</span>
                        </label>
                        <input
                          id="amt-pay"
                          ref="amt-pay"
                          type="number"
                          required
                          placeholder=" 0.00"
                          disabled
                          class="form-control amtpay"
                          v-model="
                            state.billing.billing.return_flow
                              .return_confirm_data.total
                          "
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <label class="mt-2 mb-1">Select Refund Method</label>

                  <div class="row">
                    <div class="col-md-6 pr-1" v-if="getRefundType.cash">
                      <b-button
                        block
                        variant="outline-secondary"
                        class="text-center p-0 h-25 mb-3"
                        :disabled="disableRefundType"
                        @click="openModal('Cash')"
                        id="cash-btn"
                      >
                        <img
                          src="@/assets/images/cash-dark.svg"
                          alt="Cash"
                        />&nbsp; Cash
                      </b-button>
                    </div>
                    <div
                      class="col-md-6 pl-1"
                      v-show="getRefundType.store_credit"
                    >
                      <b-button
                        block
                        variant="outline-secondary"
                        class="text-center p-0 h-25 mb-3"
                        :disabled="disableRefundType"
                        @click="openModal('Voucher')"
                        id="voucher-btn"
                        >Voucher</b-button
                      >
                    </div>
                  </div>
                  <!-- <customer-info-checkout /> -->
                  <!-- Cash Modal -->
                  <b-modal
                    ref="cash-modal"
                    size="sm"
                    centered
                    id="pay"
                    :title="refundType"
                    hide-footer
                    :hide-header="$loading == true"
                    no-close-on-backdrop
                    no-close-on-esc
                  >
                    <b-form @submit.prevent v-if="$loading == false">
                      <b-form-group
                        id="group-refund-amount"
                        label="Refund Amount"
                        label-for="input-1"
                      >
                        <input
                          id="input-refund-amount"
                          type="number"
                          size="sm"
                          min="0"
                          class="form-control"
                          autofocus
                          autocomplete="off"
                          placeholder="Enter Amount"
                          disabled
                          v-model="
                            state.billing.billing.return_flow
                              .return_confirm_data.total
                          "
                        />
                      </b-form-group>

                      <b-button
                        variant="primary"
                        type="submit"
                        class="float-right mt-3"
                        @click="confirmReturn"
                        id="continue"
                      >
                        <span v-if="$loading == false">Continue</span>
                        <b-spinner small v-if="$loading == true"></b-spinner>
                      </b-button>
                    </b-form>
                    <div v-if="$loading == true" class="m-1">
                      <h6 style="font-weight: normal;">Processing Refund</h6>
                      <b-progress
                        :value="100"
                        variant="primary"
                        striped
                        animated
                        class="mt-3"
                      ></b-progress>
                    </div>
                  </b-modal>
                </div>
              </div>
              <div class="customer-info table-dark-bg box-shadow p-3">
                <b-row>
                  <!-- <b-col lg="8"> -->
                  <b-col lg="6" class>
                    <label for class="mb-0">Customer Name</label>
                    <p
                      v-text="
                        state.billing.billing.return_flow.customer_info.name
                      "
                    ></p>
                  </b-col>
                  <b-col lg="6" class>
                    <label for class="mb-0">Phone Number</label>
                    <p
                      v-text="
                        state.billing.billing.return_flow.customer_info.mobile
                      "
                    ></p>
                  </b-col>
                  <b-col lg="12" class>
                    <div class="d-flex mb-1">
                      <label for class="mb-0 mr-2">Return Remark</label>
                      <a
                        href="javascript:void(0)"
                        v-b-modal.return-remarks
                        id="show-remark"
                      >
                        <font-awesome-icon :icon="['fas', 'pen']" size="1x" />
                      </a>
                    </div>
                    <p class="mb-1">
                      <span
                        class="text-muted"
                        v-if="state.billing.billing.return_flow.remarks == ''"
                        >Add Return Remarks &nbsp;</span
                      >
                      <span v-else class="return-remarks">
                        {{ state.billing.billing.return_flow.remarks }}
                        &nbsp;
                      </span>

                      <!--Add remark modal-->
                      <b-modal
                        hide-footer
                        centered
                        id="return-remarks"
                        title="Return Remarks"
                        ref="return-remarks-modal"
                      >
                        <b-form @submit.prevent="saveRemarks">
                          <label for>Remark</label>
                          <b-form-textarea
                            placeholder="Add remark... "
                            id="remark"
                            aria-describedby="remark-validation"
                            cols="30"
                            rows="5"
                            v-model="$v.form.remark.$model"
                            :state="
                              $v.form.remark.$dirty
                                ? !$v.form.remark.$error
                                : null
                            "
                          ></b-form-textarea>

                          <b-form-invalid-feedback id="remark-validation"
                            >Please enter your remark</b-form-invalid-feedback
                          >

                          <div class="text-right">
                            <b-button
                              class="mt-3 mr-2 danger-btn"
                              variant="danger"
                              type="reset"
                              @click="resetForm"
                              :disabled="$v.form.$invalid"
                              id="clear-remark"
                            >
                              <span v-if="$loading == false">Clear</span>
                              <b-spinner
                                small
                                v-if="$loading == true"
                              ></b-spinner>
                            </b-button>
                            <b-button
                              class="grey-btn mt-3"
                              variant="success"
                              type="submit"
                              id="save-remark"
                              :disabled="$v.form.$invalid"
                            >
                              <span v-if="$loading == false">Save</span>
                              <b-spinner
                                small
                                v-if="$loading == true"
                              ></b-spinner>
                            </b-button>
                          </div>
                        </b-form>
                      </b-modal>
                    </p>
                  </b-col>
                  <!-- </b-col> -->
                </b-row>
              </div>
              <!-- <b-col lg="1" class="text-lg-right text-sm-left mt-lg-0 mt-md-2">
                <label for class="mb-0">Quantity</label>
                <p v-text="state.billing.billing.return_flow.return_confirm_data.cart_qty_total"></p>
              </b-col>-->
              <!-- <b-col lg="2" class="text-lg-right text-sm-left mt-lg-0 mt-md-2">
                <div class="d-flex mb-1 justify-content-md-end justify-content-sm-start">
                  <label for class="mb-0 mr-2">Refund Mode</label>
                  <a href="javascript:void(0)" v-b-modal.return-mode>
                    <font-awesome-icon :icon="['fas', 'pen']" size="1x" />
                  </a>
                  <b-modal
                    hide-footer
                    centered
                    size="sm"
                    id="return-mode"
                    title="Return Mode"
                    ref="return-mode-modal"
                  >
                    <b-form-group>
                      <div
                        class="pt-2 pb-1 px-3 mb-2"
                        :class="refundType=='Voucher'?'highlighted':''"
                      >
                        <b-form-radio
                          v-model="refundType"
                          name="store-credit"
                          value="Voucher"
                        >Store Credit Voucher</b-form-radio>
                      </div>
                      <div class="pt-2 pb-1 px-3" :class="refundType=='Cash'?'highlighted':''">
                        <b-form-radio
                          v-model="refundType"
                          name="cash-refund"
                          value="Cash"
                        >Cash Refund</b-form-radio>
                      </div>
                    </b-form-group>
                    <div class="text-right">
                      <b-button
                        class="grey-btn mt-3"
                        variant="success"
                        @click="setRefundType"
                      >confirm</b-button>
                    </div>
                  </b-modal>
                </div>
                <p v-text="refundType" class="mr-4"></p>
              </b-col>-->
              <!-- <b-col lg="2" class="text-lg-right text-sm-left mt-lg-0 mt-md-2">
                <label for class="mb-0">Refund Amount</label>
                <p>{{currencySymbol}} {{ state.billing.billing.return_flow.return_confirm_data.total }}</p>
              </b-col>-->
            </div>
            <div class="col-lg-8 pl-0 fadein">
              <return-order-summary />
            </div>
          </b-row>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
// import axios from "axios";
import { mapState } from "vuex";
import * as msg from "../message";
import * as helper from "../helper";
import ReturnOrderSummary from "../components/ReturnOrderSummary";

export default {
  name: "return-confirmation",
  mixins: [validationMixin],
  props: ["order_id"],
  value: 0,

  components: {
    Dashboard,
    Loading,
    ReturnOrderSummary,
  },

  computed: {
    ...mapState({
      state: (state) => state,
    }),
    returnItems() {
      let data = [];
      this.state.billing.billing.return_flow.return_confirm_data.data.map(
        (item, index) => {
          data.push({
            id: index + 1,
            discount: item.product_data.discount,
            product: item.product_data.p_name,
            barcode: item.product_data.barcode,
            sale_price: item.product_data.s_price,
            net_price: item.product_data.r_price,
            return_qty: item.product_data.return_qty,
            return_reason: item.product_data.reason,
          });
        }
      );
      return data;
    },
    getOrderIdLength() {
      let length = this.state.system.settings.vendor_app_menu.offline
        .offline_invoice_id_format.order_id.name.length;
      return length;
    },
    isOfflineEnabled() {
      let check = false;
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1
      ) {
        check = true;
      }
      return check;
    },
    disableRefundType() {
      let check = false;
      if (
        (this.state.billing.billing.return_flow.return_confirm_data.hasOwnProperty(
          "total"
        ) &&
          parseFloat(
            this.state.billing.billing.return_flow.return_confirm_data.total
          ) == 0) ||
        !this.state.billing.billing.return_flow.return_confirm_data.hasOwnProperty(
          "total"
        )
      )
        check = true;
      return check;
    },
    getRefundType() {
      return this.$store.getters["system/getRefundType"];
    },
  },
  data() {
    return {
      Title: "Return Confirmation",
      returnReasons: null,
      refundType: "",
      loading: true,
      searchableName: true,
      isContentShow: false,
      dataSet: [],
      returnValue: 1,
      form: {
        remark: "",
      },
      options: [
        { value: null, text: "Please select an reason" },
        { value: "1", text: "Return Reason 1" },
        { value: "2", text: "Return Reason 2" },
        { value: "3", text: "Return Reason 3" },
        { value: "custom", text: "Add custom remark.." },
      ],
    };
  },
  validations: {
    form: {
      remark: {
        required,
        minLength: minLength(3),
      },
    },
  },
  mounted() {
    this.form.remark = this.state.billing.billing.return_flow.remarks;
    if (this.isOfflineEnabled) {
      helper.getInvoiceId("invoice_id");
    }
  },
  beforeDestroy() {
    if (this.state.billing.auto_print_enable)
      this.$store.commit("billing/printMode", 1);
  },
  methods: {
    openModal(type) {
      this.refundType = type;
      this.$refs["cash-modal"].show();
    },
    setRefundType() {
      this.$refs["return-mode-modal"].hide();
    },
    openCustomRemark() {
      if (this.returnReasons == "custom") {
        this.$refs["return-remarks-modal"].show();
      }
    },
    editReturnItems() {
      this.$router.push("/return-items");
    },
    resetForm() {
      this.form.remark = "";
      this.state.billing.billing.return_flow.remarks = "";
      this.$refs["return-remarks-modal"].hide();
      let alertData = {
        message: msg.REMARK_REMOVED,
        type: "success",
      };
      this.$showAlert = false;
      this.$store.commit("notifications/showAlert", alertData);
    },
    saveRemarks() {
      this.$loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.state.billing.billing.return_flow.remarks = this.form.remark;
        this.$loading = false;
        this.$refs["return-remarks-modal"].hide();
        let alertData = {
          message: msg.REMARK_ADDED,
          type: "success",
        };
        this.$showAlert = false;
        this.$store.commit("notifications/showAlert", alertData);
      }
    },
    confirmReturn() {
      let order_id = "";
      if (this.isOfflineEnabled) {
        // helper.getInvoiceId("invoice_id");
        order_id = this.state.billing.billing.invoice_no;
        order_id = order_id.substring(order_id.length - this.getOrderIdLength);
      }
      this.$loading = true;
      let returnItem = [];
      this.state.billing.billing.return_flow.product_list.map((item) => {
        if (item.status) {
          returnItem.push({
            item_id: item.barcode,
            qty: item.selected_qty,
            reason_id: item.return_reason,
            batch_id: item.batch_id,
            serial_id: item.serial_id,
            unit_mrp: item.unit_mrp,
          });
        }
      });
      let data = {
        api_token: this.state.sessions.api_token,
        customer_id: this.state.billing.billing.return_flow.customer_info.c_id,
        v_id: this.state.sessions.user.vendor_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        admin_id: this.state.sessions.user.id,
        order_id: this.state.billing.billing.return_flow.invoice,
        confirm: 1,
        remark: this.state.billing.billing.return_flow.remarks,
        return_item: JSON.stringify(returnItem),
        invoice_seq: order_id,
        url: "/return/approve",
        credit_issue: this.refundType.toLowerCase(),
      };
      this.$store
        .dispatch("billing/confirmReturn", data)
        .then(() => {
          this.$loading = false;
          this.$store.dispatch("billing/saveInvoiceId");
          this.$router.push("/return-successfull");
        })
        .catch(() => {
          this.$loading = false;
        });
      // $router.push("../return-successfull");
    },
  },
};
</script>
<style lang="scss" scoped>
// .bg-black {
//   background-color: #000;
//   border: 1px #606060 solid;
//   color: #fff;
// }
// .theme-light .bg-black {
//   background-color: transparent;
//   border: 1px #c0c0c0 solid;
//   color: #404040;
// }
.theme-light .payment-page label {
  color: #606060 !important;
  font-size: 14px;
}
.pay input:last-child:read-only {
  background-color: transparent !important;
  border: 1px #c0c0c0 solid !important;
  color: #808080;
}
.btn-outline-secondary.dropdown-toggle:active {
  background: #76767680;
  border: 1px #76767680 solid;
}
.amtpay {
  color: #848484;
}
.payment-page .py-2 {
  padding-bottom: 0.8rem !important;
  padding-top: 0.8rem !important;
}
.payment-page .h-25 {
  height: 40px !important;
}
.return-method {
  height: calc(100vh - 208px) !important;
}
.highlighted {
  background: $body-color-light;
  border-radius: 5px;
}
.return-remarks {
  display: inline-block;
  width: 72%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
}
.custom-select {
  font-size: 13px;
}
.table-dark td {
  padding: 1rem 0.4rem;
}
.theme-light .customer-info-data {
  background: $grey-btn-bg;
  height: calc(100vh - 69px);
}

.cart-table-wrapper {
  height: calc(100vh - 160px);
}

h5 {
  color: $grey-color;
}
.btn-danger {
  text-overflow: none;
}

.pay-amount .form-control {
  background: transparent;
  font-size: 18px;
}
</style>
